(() => {

  // 初期化処理
  const init = () => {
    // 各初期化関数の呼び出し
    accordion();
    initSmoothScroll();
    initDetailModal();
    initHeaderScrollUp();
  };

  // リサイズ
  const handleResize = () => {
    // 各初期化関数の呼び出し
  };

  // スクロール
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
    }
  };

  /**
   * data-scroll-up が true のとき:
   * - data-sticky を false に書き換え
   * - 下にスクロール: クラスを削除してヘッダーを隠す
   * - 上にスクロール: #SiteHeader に site-header--stuck を付ける
   */
  const initHeaderScrollUp = () => {
    const header = document.getElementById('SiteHeader');
    if (!header || header.dataset.scrollUp !== 'true') return;

    header.dataset.sticky = 'false';

    const wrapperId = 'StickyHeaderWrap';
    let wrapper = document.getElementById(wrapperId);
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = wrapperId;
      header.parentNode.insertBefore(wrapper, header);
      wrapper.appendChild(header);
    }

    const setWrapperHeight = () => {
      wrapper.style.height = header.offsetHeight + 'px';
    };

    let lastScroll = window.scrollY;
    const threshold = 250;
    const scrollDeltaThreshold = 5;
    const stuckClass = 'site-header--stuck';
    const hiddenClass = 'site-header--scroll-up-hidden';

    const onScroll = () => {
      const currentScroll = window.scrollY;
      const delta = currentScroll - lastScroll;
      const scrollingDown = delta > scrollDeltaThreshold;
      const scrollingUp = delta < -scrollDeltaThreshold;

      if (currentScroll <= threshold) {
        header.classList.remove(stuckClass);
        header.classList.remove('site-header--opening');
        header.classList.remove(hiddenClass);
      } else if (scrollingDown) {
        header.classList.add(hiddenClass);
      } else if (scrollingUp) {
        header.classList.remove(hiddenClass);
        header.classList.add(stuckClass);
        setTimeout(() => {
          header.classList.add('site-header--opening');
        }, 10);
      }

      lastScroll = currentScroll;
    };

    setWrapperHeight();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setWrapperHeight);
  };

  // アコーディオン開閉
  const accordion = () => {

    const moreBtn = Array.from(document.querySelectorAll('.js-accordion-btn'));

    moreBtn.forEach((item) => {
      item.addEventListener('click', function() {
        this.classList.toggle('is-on');
        const target = this.nextElementSibling;
        
        if (target.style.maxHeight) {
          target.style.maxHeight = null;
        } else {
          target.style.maxHeight = target.scrollHeight + 'px';
        }
      });
    });
  }

  // スクロール位置の調整
  const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = document.getElementById('header')?.clientHeight || 0 + 80;
    const target = rect + offset - gap;
  
    window.scrollTo({ top: target, behavior });
  };

  // スムーススクロール
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        const targetId = trigger.getAttribute('href').replace('#', '');
        const targetElement = document.getElementById(targetId);
        if (targetElement) adjustScrollPosition(targetElement, 'smooth');
      });
    });
  };

  // モーダル（共通）
  const initDetailModal = () => {
    const triggers = document.querySelectorAll('.js-detail-modal-trigger');
    const closeButtons = document.querySelectorAll('.js-modal-close');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const blockId = trigger.getAttribute('data-block-id');
        if (!blockId) return;

        const section = trigger.closest('.mamykuru-detail-modal') || trigger.closest('section');
        const modal = section ? section.querySelector('.modal-content') : null;
        if (!modal) return;

        const imageEl = modal.querySelector('.js-modal-image');
        const titleEl = modal.querySelector('.js-modal-title');
        const textEl = modal.querySelector('.js-modal-text');

        if (imageEl) {
          imageEl.src = trigger.getAttribute('data-modal-image') || '';
          imageEl.alt = trigger.getAttribute('data-modal-title-alt') || '';
        }
        if (titleEl) {
          const titleSource = document.getElementById(`modal-title-${blockId}`);
          titleEl.innerHTML = titleSource ? titleSource.innerHTML : '';
        }
        if (textEl) {
          const template = document.getElementById(`modal-content-${blockId}`);
          textEl.innerHTML = '';
          if (template && template.content) {
            textEl.appendChild(template.content.cloneNode(true));
          }
        }

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    const closeModal = (modal) => {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const modal = btn.closest('.modal-content');
        closeModal(modal);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const openModal = document.querySelector('.modal-content.is-open');
      closeModal(openModal);
    });
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();